import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { AttachmentsTypesDetailComponent } from '../attachments-types-detail/attachments-types-detail.component';
import { AttachmentsTypesService } from '../attachments-types.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-attachments-types-list',
  templateUrl: './attachments-types-list.component.html',
  styleUrls: ['./attachments-types-list.component.scss']
})
export class AttachmentsTypesListComponent implements OnInit {

  @ViewChild("view") public view: ViewComponent;
  public attachmentsTypesFilters: any = {};
  public attachment_type_id;

  constructor(
    private attachmentsTypesService: AttachmentsTypesService,
    private dialogService: DialogService,
    private coreDialogService: CoreDialogService,
    private messageService: MessageService,
    private viewsService: ViewsService,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.attachment_type_id = this.activatedRoute.snapshot.params.attachment_type_id;
  }

  viewAttachmentType(attachmentType) {
    const ref = this.dialogService.open(AttachmentsTypesDetailComponent, {
      data: {
        id: attachmentType ? attachmentType.id : 0,
        attachment_type_type_id: this.attachment_type_id
      },
      width: '40%',
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.view.fireEvent("attachmentsTypes.list.results", "reload");
    });
  }

  deleteAttachmentType(attachmentType) {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.attachmentType.delete_message", { name: attachmentType.name }),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.attachmentsTypesService.delete(attachmentType.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            this.view.fireEvent("attachmentsTypes.list.results", "reload");
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: () => { }
    });
  }

  onEvent(event: any) {
    if (event.component == "attachmentsTypes.list.filters") {
      if (event.event == "action" && event.action.name == "search") this.view.fireEvent("attachmentsTypes.list.results", "reload");
    } else if (event.component == "attachmentsTypes.list.results") {
      if (event.event == "dblclick") this.viewAttachmentType(event.data);
      if (event.event == "action" && event.action.name == "add") this.viewAttachmentType(null);
      if (event.event == "action" && event.action.name == "edit") this.viewAttachmentType(event.data);
      if (event.event == "action" && event.action.name == "delete") this.deleteAttachmentType(event.data);
    }
  }
}
